import { useEffect } from "react";
import { Typography } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { setTime, setstartTimer } from "../reducers/global-reducer";

const Timer = () => {
    const dispatch = useDispatch();
    const { time, startTimer } = useSelector(state => state.globalreducer);
    const { seconds, minutes } = time;

    // Timer function for Counting time for OTP 
    useEffect(() => {
        if (startTimer) {
            let myInterval = setInterval(() => {
                if (seconds > 0) {
                    dispatch(setTime({ ...time, seconds: seconds - 1 }));
                } else if (minutes > 0) {
                    dispatch(setTime({ ...time, minutes: minutes - 1, seconds: 59 }));
                } else {
                    clearInterval(myInterval);
                    dispatch(setstartTimer(false)); // Optional: stop the timer
                }
            }, 1000);
            return () => clearInterval(myInterval);
        }
    }, [seconds, minutes, startTimer]);

    return(
        <>
            <div style={{position: 'absolute', top: '20px', right: '-60px'}}>
                <Typography variant="h6"> {minutes}:{seconds < 10 ?  `0${seconds}` : seconds}</Typography> 
            </div>
        </>
    )
}

export default Timer;